/* Black Friday hub: SN Module Nav (sticky under real header, scroll spy, empty groups) and rules card layout. */
(function () {
  'use strict';

  if (window.__snBfcmHub) return;
  window.__snBfcmHub = true;

  var HEADER_SELECTOR = 'announcement-bar, .shopify-section-group-header-group, .shopify-section-header, #header-component, sticky-header';
  var MENU_OPEN_SELECTOR = '#header-component[data-sn-panel], .header__dropdown-toggle[aria-expanded="true"], .hamburger.is-opened, [id^="HeaderDropdownMenu"][aria-hidden="false"]';
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Bottom edge of the sticky header / announcement bar currently pinned at the top of the viewport. */
  function headerBottom() {
    var bottom = 0;
    var nodes = document.querySelectorAll(HEADER_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var style = window.getComputedStyle(nodes[i]);
      if (style.display === 'none' || style.visibility === 'hidden') continue;
      var rect = nodes[i].getBoundingClientRect();
      if (rect.width && rect.bottom > 0 && rect.top < 180 && rect.bottom < window.innerHeight * 0.6) {
        bottom = Math.max(bottom, rect.bottom);
      }
    }
    return Math.round(bottom);
  }

  function initNav(nav) {
    if (nav.__snNav) return;
    nav.__snNav = true;

    var inner = nav.querySelector('.sn-module-nav__inner');
    var links = Array.prototype.slice.call(nav.querySelectorAll('[data-sn-module-nav-link]'));
    var sticky = nav.hasAttribute('data-sticky');
    var autoOffset = nav.hasAttribute('data-auto-offset');
    var manualOffset = parseInt(nav.getAttribute('data-offset'), 10) || 0;
    var hideHeader = sticky && nav.hasAttribute('data-hide-header');
    var headerOffset = 0;
    var spy = nav.hasAttribute('data-scroll-spy');
    var hideEmpty = nav.hasAttribute('data-hide-empty');
    var requireProducts = nav.hasAttribute('data-require-products');
    var placeholder = null;
    var current = null;
    var frame = 0;
    var lockUntil = 0;

    if (designMode) nav.classList.add('is-design-mode');
    if (hideHeader) document.documentElement.classList.add('sn-module-nav-page');

    function targetOf(link) {
      var id = (link.getAttribute('href') || '').replace(/^#/, '');
      if (!id) return null;
      try {
        return document.getElementById(decodeURIComponent(id));
      } catch (e) {
        return null;
      }
    }

    function topOffset() {
      return autoOffset ? headerBottom() : manualOffset;
    }

    /* Content a link points at: the anchor's section, or the next section for a standalone SN Page Anchor. */
    function regionOf(target) {
      var section = target.closest('.shopify-section');
      if (!section) return target;
      if (target.hasAttribute('data-sn-page-anchor')) return section.nextElementSibling;
      return section;
    }

    function isEmpty(link) {
      var target = targetOf(link);
      if (!target) return true;
      var region = regionOf(target);
      if (!region || !region.getClientRects().length || region.offsetHeight < 20) return true;
      return requireProducts && !region.querySelector('a[href*="/products/"]');
    }

    function visibleLinks() {
      return links.filter(function (link) {
        return !link.hidden && !link.classList.contains('is-empty');
      });
    }

    function undock() {
      nav.classList.remove('is-fixed');
      if (placeholder) {
        placeholder.remove();
        placeholder = null;
      }
    }

    function dock() {
      if (!placeholder) {
        placeholder = document.createElement('div');
        placeholder.setAttribute('aria-hidden', 'true');
        placeholder.style.height = nav.offsetHeight + 'px';
        /* Same background as the bar, so the slot never shows as a white gap. */
        placeholder.style.background = window.getComputedStyle(nav).background;
        nav.parentNode.insertBefore(placeholder, nav);
      }
      nav.classList.add('is-fixed');
    }

    function setHeaderHidden(hidden) {
      document.documentElement.classList.toggle('sn-module-nav-hide-header', hidden);
    }

    function mark(link) {
      if (link === current) return;
      current = link;
      links.forEach(function (item) {
        var on = item === link;
        item.classList.toggle('is-active', on);
        if (on) item.setAttribute('aria-current', 'location');
        else item.removeAttribute('aria-current');
      });
      if (link && inner && inner.scrollWidth > inner.clientWidth + 1) {
        inner.scrollTo({
          left: link.offsetLeft - (inner.clientWidth - link.offsetWidth) / 2,
          behavior: reducedMotion() ? 'auto' : 'smooth'
        });
      }
    }

    function markFromHash() {
      var hash = (window.location.hash || '').replace(/^#/, '');
      var items = visibleLinks();
      var match = null;
      items.forEach(function (link) {
        if (hash && (link.getAttribute('href') || '').replace(/^#/, '') === hash) match = link;
      });
      mark(match || items[0] || null);
    }

    function markFromScroll(top) {
      var items = visibleLinks();
      var line = top + nav.offsetHeight + 24;
      var active = items[0] || null;
      var nearBottom = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 4;
      items.forEach(function (link) {
        var target = targetOf(link);
        if (!target) return;
        var y = target.getBoundingClientRect().top;
        if (y <= line || (nearBottom && y < window.innerHeight)) active = link;
      });
      mark(active);
    }

    function sync() {
      frame = 0;
      if (!nav.isConnected) return;
      if (nav.hidden) {
        undock();
        if (hideHeader) setHeaderHidden(false);
        return;
      }
      var top;
      if (hideHeader) {
        /* The header slides away as soon as the bar reaches its bottom edge; the bar keeps scrolling with the page
           and only pins once it reaches the very top, when its own slot has just left the screen — so no empty
           slot shows. The header can't be measured while hidden, so the offset from when it was shown is kept. */
        if (!document.documentElement.classList.contains('sn-module-nav-hide-header')) headerOffset = topOffset();
        var slotTop = (placeholder || nav).getBoundingClientRect().top;
        setHeaderHidden(slotTop <= headerOffset);
        if (slotTop <= 0) dock();
        else undock();
        top = 0;
      } else {
        top = topOffset();
        if (sticky) {
          if ((placeholder || nav).getBoundingClientRect().top <= top) dock();
          else undock();
        }
      }
      nav.style.setProperty('--sn-nav-top', top + 'px');
      nav.classList.toggle('is-under-header', !!document.querySelector(MENU_OPEN_SELECTOR));
      if (spy && Date.now() > lockUntil) markFromScroll(top);
    }

    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(sync);
    }

    function refreshItems() {
      if (!nav.isConnected) return;
      if (hideEmpty) {
        links.forEach(function (link) {
          link.classList.toggle('is-empty', !link.hidden && isEmpty(link));
        });
        nav.hidden = !designMode && visibleLinks().length === 0;
      }
      if (current && (current.hidden || current.classList.contains('is-empty'))) current = null;
      if (!spy) markFromHash();
      schedule();
    }

    nav.addEventListener('click', function (event) {
      var link = event.target.closest('[data-sn-module-nav-link]');
      if (!link) return;
      var target = targetOf(link);
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      var navHeight = sticky ? nav.offsetHeight : 0;
      var y = window.pageYOffset + target.getBoundingClientRect().top - (hideHeader ? 0 : topOffset()) - navHeight - 8;
      if (history.pushState) history.pushState(null, '', link.getAttribute('href'));
      lockUntil = Date.now() + 900;
      mark(link);
      window.scrollTo({ top: Math.max(0, y), behavior: reducedMotion() ? 'auto' : 'smooth' });
    });

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () {
      if (placeholder) placeholder.style.height = nav.offsetHeight + 'px';
      refreshItems();
    });
    window.addEventListener('hashchange', function () {
      if (!spy) markFromHash();
    });
    window.addEventListener('load', refreshItems);
    document.addEventListener('sn-bfcm:phase', refreshItems);

    var header = document.getElementById('header-component');
    if (header && window.MutationObserver) {
      new MutationObserver(schedule).observe(header, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class', 'data-sn-panel', 'aria-expanded', 'aria-hidden']
      });
    }

    refreshItems();
    window.setTimeout(refreshItems, 1500);
  }

  /* Rules cards: first visible card is the primary one, auto column count follows the visible cards. */
  function initRules(root) {
    if (root.__snRules) return;
    root.__snRules = true;

    function update() {
      if (!root.isConnected) return;
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sn-bfh-card]'));
      var visible = cards.filter(function (card) {
        return !card.hidden;
      });
      cards.forEach(function (card) {
        card.classList.toggle('is-primary', card === visible[0]);
      });
      root.style.setProperty('--sn-bfh-count', Math.max(1, Math.min(visible.length, 4)));
      root.hidden = !designMode && visible.length === 0;
    }

    document.addEventListener('sn-bfcm:phase', update);
    update();
  }

  function initAll(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-sn-module-nav]'), initNav);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-sn-bfh-rules]'), initRules);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
